import React from 'react';

interface InnerProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

const InputChoiceSelect: React.FC<InnerProps> = ({ label, ...rest }) => (
  <label className="flex-1 flex relative">
    <input type="radio" className="absolute right-0 self-end justify-self-center opacity-0 peer" value={label} {...rest} />
    <span className="text-center p-3.5 cursor-pointer rounded flex-1 font-semibold box-border border-whitesmoke border-2 border-solid bg-white text-sm text-black peer-checked:border-navy-blue">
      {label}
    </span>
  </label>
);

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  labels: string[];
  name: string;
}

export const ChoiceSelect: React.FC<Props> = ({ name, labels, defaultValue, ...rest }) => (
  <div className="flex flex-row gap-4">
    {labels.map((label) => (
      <InputChoiceSelect key={label} label={label} name={name} {...rest} defaultChecked={defaultValue === label} />
    ))}
  </div>
);
